import React from 'react';
import { View, Text, StyleSheet, Platform } from 'react-native';
import * as Updates from 'expo-updates';
import Constants from 'expo-constants';

export function AppVersionInfo() {
  if (Platform.OS === 'web') {
    return null;
  }

  const { currentlyRunning } = Updates.useUpdates();

  const appVersion = Constants.expoConfig?.version || 'Unknown';
  const runtimeVersion = typeof Constants.expoConfig?.runtimeVersion === 'string'
    ? Constants.expoConfig.runtimeVersion
    : JSON.stringify(Constants.expoConfig?.runtimeVersion) || 'Unknown';

  return (
    <View style={styles.container}>
      <Text style={styles.heading}>App Version Information</Text>

      <View style={styles.infoRow}>
        <Text style={styles.label}>App Version:</Text>
        <Text style={styles.value}>{appVersion}</Text>
      </View>

      <View style={styles.infoRow}>
        <Text style={styles.label}>Runtime Version:</Text>
        <Text style={styles.value}>{runtimeVersion}</Text>
      </View>

      <View style={styles.infoRow}>
        <Text style={styles.label}>Update Type:</Text>
        <Text style={styles.value}>
          {currentlyRunning?.isEmbeddedLaunch
            ? 'Embedded (App Store Build)'
            : 'OTA Update'}
        </Text>
      </View>

      {currentlyRunning && !currentlyRunning.isEmbeddedLaunch && (
        <>
          <View style={styles.infoRow}>
            <Text style={styles.label}>Update ID:</Text>
            <Text style={[styles.value, styles.mono]} numberOfLines={1}>
              {currentlyRunning.updateId?.substring(0, 8) || 'N/A'}
            </Text>
          </View>

          {currentlyRunning.createdAt && (
            <View style={styles.infoRow}>
              <Text style={styles.label}>Published:</Text>
              <Text style={styles.value}>
                {new Date(currentlyRunning.createdAt).toLocaleString()}
              </Text>
            </View>
          )}

          {currentlyRunning.channel && (
            <View style={styles.infoRow}>
              <Text style={styles.label}>Channel:</Text>
              <Text style={styles.value}>{currentlyRunning.channel}</Text>
            </View>
          )}
        </>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#fff',
    padding: 16,
    borderRadius: 10,
    marginBottom: 16,
  },
  heading: {
    fontSize: 16,
    fontWeight: '600',
    marginBottom: 12,
    color: '#222',
  },
  infoRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },
  label: {
    fontSize: 14,
    color: '#666',
    fontWeight: '500',
  },
  value: {
    fontSize: 14,
    color: '#222',
    fontWeight: '400',
    maxWidth: '60%',
    textAlign: 'right',
  },
  mono: {
    fontFamily: Platform.OS === 'ios' ? 'Courier' : 'monospace',
  },
});

